import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import {
  Branch,
  SeoExam,
  SeoSpecialty,
} from '@medprev-web-app/api-graphql-client';

import CtaModalBranchesList from '@/app/(main)/(pages)/(institucional)/(index)/_components/cta/modals/cta-modal-branches-list.component';
import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { SearchType } from '@/types/most-search-type';
import { Place } from '@/types/google-maps.types';
import { useModal } from '@/hooks/use-modal.hook';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface CtaProcedureBranchesButtonProps {
  onlyBranches: boolean;
  combinedWithOthers: boolean;
  singleBranchPhoneUrl: string | null;
  branchesLength: number;
  branches?: Array<Branch | null> | null;
  procedure?: SeoSpecialty | SeoExam | null;
  place: Pick<Place, 'state' | 'city'>;
  searchType: SearchType;
  originCta?: string;
}

export function CtaProcedureBranchesButton({
  onlyBranches,
  combinedWithOthers,
  branchesLength,
  singleBranchPhoneUrl,
  branches,
  procedure,
  place,
  searchType,
  originCta,
}: CtaProcedureBranchesButtonProps) {
  const {
    open: isBranchListModalOpen,
    onOpenChange: setIsOpenBranchListModal,
  } = useModal();

  const properties
    = searchType == SearchType.LABORATORIAL_EXAM
      ? { exame_nome: procedure?.name }
      : { especialidade_nome: procedure?.name };

  const onClickHasMultipleBranches = (): void => {
    setIsOpenBranchListModal(true);
  };

  const buttonStyleProps = onlyBranches
    ? { variant: 'default' as const }
    : combinedWithOthers
      ? { variant: 'secondary' as const, color: 'primary' as const }
      : undefined;

  if (branchesLength == 1 && singleBranchPhoneUrl !== null) {
    return (
      <Link
        prefetch={false}
        data-testid={DataTestIdEnum.SEO_CTA_SCHEDULE_SINGLE_BRANCH_BUTTON}
        href={singleBranchPhoneUrl}
        target="_blank"
        data-analytics-event={
          searchType == SearchType.LABORATORIAL_EXAM
            ? AnalyticsEnum.CLICK_CTA_SCHEDULE_EXAM_BY_ASSISTED_PURCHASE_BUTTON
            : AnalyticsEnum.CLICK_CTA_SCHEDULE_SPECIALTY_BY_SUPPORT
        }
        data-analytics-properties={JSON.stringify({
          secao_origem: originCta,
          cidade: place.city,
          estado: place.state,
          ...properties,
        })}
      >
        <Button startIcon={faWhatsapp} {...buttonStyleProps}>
          Agendar com atendente
        </Button>
      </Link>
    );
  } else if (branchesLength > 1) {
    return (
      <>
        <Button
          data-testid={DataTestIdEnum.SEO_CTA_SCHEDULE_MULTIPLE_BRANCHES_BUTTON}
          startIcon={faWhatsapp}
          onClick={onClickHasMultipleBranches}
          data-analytics-event={
            searchType == SearchType.LABORATORIAL_EXAM
              ? AnalyticsEnum.CLICK_CTA_SCHEDULE_EXAM_BY_ASSISTED_PURCHASE_BUTTON
              : AnalyticsEnum.CLICK_CTA_SCHEDULE_SPECIALTY_BY_SUPPORT
          }
          data-analytics-properties={JSON.stringify({
            secao_origem: originCta,
            cidade: place.city,
            estado: place.state,
            ...properties,
          })}
          {...buttonStyleProps}
        >
          Agendar com atendente
        </Button>

        <CtaModalBranchesList
          open={isBranchListModalOpen}
          onOpenChange={setIsOpenBranchListModal}
          branches={branches}
          procedure={procedure}
          place={place}
          searchType={searchType}
        />
      </>
    );
  } else {
    return null;
  }
}
